import { API, graphqlOperation } from "aws-amplify";
import { zoneByAreaBySortKey } from "../../../../graphql/queries";
import { inventoryItemByAisleByStatusMini } from "../../../../graphql/inventory/custom-queries";
import { locationByAisleByActiveBySortKey } from "../../../../graphql/location/custom-queries";
import { locationByAisleBySortKey } from "../../../../graphql/reloadyard/custom-queries";
import {
  createLocation,
  deleteAisle,
  deleteLocation,
  updateAisle,
  updateLocation,
} from "../../../../graphql/mutations";
import { updateInventoryItemMini } from "../../../../graphql/inventory/custom-mutations";

import {
  AreaType,
  InventoryStatus,
  LocationType,
  VALIDATION_MSG,
} from "../../../../utils/constants";
import { logError } from "../../../../utils/appUtils";
import {
  doUpdateLocation,
  getLocationFullName,
  hasTrackCarsOnLocations,
  isTrack,
} from "../../../../utils/locationUtils";

// === Setup Functions ===
export const defaultLocationLoad = {
  other: { selected: false, capacity: 0 },
  container: { selected: false, capacity: 100 },
  pallet: { selected: false, capacity: 100 },
  box: { selected: false, capacity: 50 },
  superSack: { selected: false, capacity: 100 },
  dryBulk: { selected: false, capacity: 0 },
  liquidBulk: { selected: false, capacity: 0 },
};

export const getZones = async (record, setZones, setSelectedZoneId, notify) => {
  try {
    const response = await API.graphql(
      graphqlOperation(zoneByAreaBySortKey, { areaId: record.areaId })
    );
    const zones = response.data.zoneByAreaBySortKey.items;
    debugger;
    setZones(zones);
    setSelectedZoneId(record.zoneId);
  } catch (err) {
    logError("reloadYard:aisleUtils:getZones", err, notify);
  }
};

export const setupAisle = async (
  record,
  selectedLocation,
  setSelectedLocation,
  setIsContainer,
  setBayList,
  notify
) => {
  try {
    debugger;
    const response = await API.graphql(
      graphqlOperation(locationByAisleByActiveBySortKey, {
        aisleId: record.id,
        limit: 1000,
        activeSortKey: { beginsWith: { active: "true" } },
      })
    );
    record.locations.items =
      response.data.locationByAisleByActiveBySortKey.items;
    const isContainer =
      record.locations.items[0]?.locationLoad?.container?.selected;
    setIsContainer(isContainer || false);
    if (selectedLocation) {
      const location = record.locations.items.find(
        (itm) => itm.id === selectedLocation.id
      );
      setSelectedLocation(location);
    }
    const bayList = [];

    for (let location of record.locations.items) {
      const bay = location.bay;
      if (!bayList[bay]) bayList[bay] = [];
      const level = location.level;
      if (!bayList[bay][level - 1]) bayList[bay][level - 1] = [];
      bayList[bay][level - 1].push(location);
    }
    bayList.splice(0, 1);
    for (let bay of bayList) {
      if (!bay || bay.length === 0) continue;
      for (let level of bay) {
        level.sort((a, b) => {
          return a.position - b.position;
        });
      }
    }
    setBayList(bayList);
  } catch (err) {
    logError("reloadYard:aisleUtils:setupAisle", err, notify);
  }
};

// === Inventory Update ===

export const doUpdateInventoryItem = (inventoryItem, selectedAisle) => {
  const inventoryLocation = selectedAisle.locations.items.find(
    (itm) => itm.id === inventoryItem.locationId
  );
  inventoryLocation.aisle = selectedAisle;
  inventoryLocation.zone = selectedAisle.zone;

  const toUpdateInventoryItem = {
    ...inventoryItem,
    locationFullName: getLocationFullName(inventoryLocation),
    zoneId: selectedAisle.zoneId,
  };

  delete toUpdateInventoryItem.area;
  delete toUpdateInventoryItem.createdAt;
  delete toUpdateInventoryItem.inventory;
  delete toUpdateInventoryItem.location;
  delete toUpdateInventoryItem.seals;
  delete toUpdateInventoryItem.updatedAt;
  delete toUpdateInventoryItem.zone;

  return API.graphql(
    graphqlOperation(updateInventoryItemMini, {
      input: toUpdateInventoryItem,
    })
  );
};

export const doDeleteLocation = (location) => {
  const input = { id: location.id };
  return API.graphql(graphqlOperation(deleteLocation, { input }));
};

export const handleAddBulkLocations = async (
  record,
  locationsPerLevel,
  setLocationsPerBayBulkError,
  updateSelectedAisle,
  setLoading,
  notify
) => {
  try {
    debugger;
    const isValid = isBulkDataValid(
      locationsPerLevel,
      setLocationsPerBayBulkError
    );
    if (!isValid) {
      notify(VALIDATION_MSG, "warning");
      return;
    }

    const promiseList = [];
    for (let i = 1; i <= locationsPerLevel; i++) {
      const input = {
        active: true,
        groups: record.groups,
        reloadYardId: record.id,
        level: 1,
        bay: record.bays,
        position: record.locations.items.length + i,
        name: record.locations.items.length + i,
        areaId: record.area.id,
        zoneId: record.zone.id,
        locationLoad: record.locationLoad,
        aisleId: record.id,
        sortKey: record.locations.items.length + i,
        type: record.type,
        capacityUsed: 0,
        capacityAllocated: 0,
        bulkCapacity: null,
        bulkUnits: "",
        productId: null,
      };
      promiseList.push(
        API.graphql(graphqlOperation(createLocation, { input }))
      );
    }
    await Promise.all(promiseList);
    const aisle = {
      ...record,
      totalLocations: record.totalLocations + locationsPerLevel,
    };
    await updateSelectedAisle(aisle);
  } catch (err) {
    logError("reloadYard:aisleUtils:handleAddBulkLocations", err, notify);
  } finally {
    setLoading(false);
  }
};

const isBulkDataValid = (locationsPerLevel, setLocationsPerBayBulkError) => {
  let isValid = locationsPerLevel ? true : false;
  if (!isValid) setLocationsPerBayBulkError(true);

  return isValid;
};

export const updateLocationPosition = (location) => {
  const toUpdateLocation = { ...location };
  toUpdateLocation.position = location.position + 1;

  delete toUpdateLocation.aisle;
  delete toUpdateLocation.area;
  delete toUpdateLocation.zone;
  delete toUpdateLocation.createdAt;
  delete toUpdateLocation.updatedAt;

  return API.graphql(
    graphqlOperation(updateLocation, { input: toUpdateLocation })
  );
};

export const createNewLocation = async (
  record,
  bayList,
  isContainer,
  bayNumber,
  level,
  position
) => {
  debugger;
  const bay = bayNumber + 1;
  let locationLoad = { ...defaultLocationLoad };
  if (isContainer)
    locationLoad.container = {
      selected: true,
      capacity: 100,
    };

  if (bayList.length > 0 && bayList[0].length > 0 && bayList[0][0].length > 0) {
    const bay = bayList[0];
    const level = bay[0];
    const location = level[0];
    locationLoad = { ...location.locationLoad };
  }

  const input = {
    active: true,
    groups: record.groups,
    reloadYardId: record.id,
    level,
    bay,
    position,
    areaId: record.area.id,
    zoneId: record.zone.id,
    aisleId: record.id,
    sortKey: 1,
    type: record.type,
    locationLoad: { ...locationLoad },
    capacityUsed: 0,
    capacityAllocated: 0,
    productId: null,
  };
  return doCreateLocation(input);
};

export const doCreateLocation = (input) => {
  return API.graphql(graphqlOperation(createLocation, { input }));
};

export const doUpdateAisle = async (aisle, updateLocations = true) => {
  const toUpdateAisle = { ...aisle };
  delete toUpdateAisle.aisleId;
  delete toUpdateAisle.area;
  delete toUpdateAisle.zone;
  delete toUpdateAisle.createdAt;
  delete toUpdateAisle.updatedAt;
  delete toUpdateAisle.bay;
  delete toUpdateAisle.level;
  delete toUpdateAisle.owner;
  delete toUpdateAisle.groups;
  delete toUpdateAisle.locations;

  const response = await API.graphql(
    graphqlOperation(updateAisle, { input: toUpdateAisle })
  );
  const updatedAisle = response.data.updateAisle;

  if (updateLocations) {
    const response = await API.graphql(
      graphqlOperation(locationByAisleBySortKey, {
        aisleId: aisle.id,
        limit: 1000,
      })
    );
    aisle.locations.items = response.data.locationByAisleBySortKey.items.filter(
      (itm) => itm.active === "true"
    );
    const promiseList = aisle.locations.items.map((location) => {
      location.active = updatedAisle.active;
      location.zoneId = updatedAisle.zoneId;
      if (aisle.type === LocationType.UNSTRUCTURED) {
        location.name = updatedAisle.name;
        // Sync track length only for unstructured (track) aisles; structured/bulk locations keep their own length
        if (updatedAisle.length != null) location.length = updatedAisle.length;
      }
      return doUpdateLocation(location);
    });

    const results = await Promise.allSettled(promiseList);
    const resError = results.find((itm) => itm.status === "rejected");
    if (resError) {
      logError("reloadYard:aisleUtils:doUpdateAisle", resError, false);
      throw resError;
    }
  }
  return updatedAisle;
};

export const handleDeleteAisle = async (selectedAisle, notify) => {
  if (!selectedAisle) return;
  let isOnTrack, isStored, isUnloaded, isReview, isShipped, isHeld;
  let results;
  debugger;

  let logLocation = "reloadYard:YardLayout:handleDelete:searchInventorys";
  try {
    if (isTrack(selectedAisle.area)) {
      // Track occupancy is keyed by TrackCar.trackId (Location.id), so check all aisle location IDs.
      const trackIds = (selectedAisle.locations?.items || []).map(
        (location) => location.id
      );
      isOnTrack = await hasTrackCarsOnLocations(trackIds);
    } else {
      const searchQuery = {
        aisleId: selectedAisle.id,
        status: { beginsWith: InventoryStatus.STORED },
        limit: 1,
      };

      results = await API.graphql(
        graphqlOperation(inventoryItemByAisleByStatusMini, searchQuery)
      );
      isStored = results.data.inventoryItemByAisleByStatus.items.length > 0;

      if (!isStored) {
        searchQuery.status.beginsWith = InventoryStatus.UNLOADED;
        results = await API.graphql(
          graphqlOperation(inventoryItemByAisleByStatusMini, searchQuery)
        );
        isUnloaded = results.data.inventoryItemByAisleByStatus.items.length > 0;

        if (!isUnloaded) {
          searchQuery.status.beginsWith = InventoryStatus.REVIEW;
          results = await API.graphql(
            graphqlOperation(inventoryItemByAisleByStatusMini, searchQuery)
          );
          isReview = results.data.inventoryItemByAisleByStatus.items.length > 0;
        }
      }

      isHeld = isStored || isUnloaded || isReview;
      if (!isHeld) {
        searchQuery.status.beginsWith = InventoryStatus.SHIPPED;
        results = await API.graphql(
          graphqlOperation(inventoryItemByAisleByStatusMini, searchQuery)
        );
        isShipped = results.data.inventoryItemByAisleByStatus.items.length > 0;
      }
    }

    logLocation = "reloadYard:YardLayout:handleDelete:deleteAisle";
    if (isHeld) {
      notify("Aisle has Locations that are in use!", "warning");
      return Promise.resolve();
    } else if (isOnTrack) {
      notify("Track has placed railcars!", "warning");
      return Promise.resolve();
    } else if (isShipped) {
      selectedAisle.active = "false";
      await doUpdateAisle(selectedAisle, true);
      notify("Aisle deleted succesfully.", "info");
    } else {
      await doDeleteAisle(selectedAisle);
      notify("Aisle deleted succesfully.", "info");
    }
  } catch (error) {
    logError(logLocation, error, notify);
    throw error;
  }
};

const doDeleteAisle = async (aisle) => {
  const promiseList = aisle.locations.items.map((itm) => doDeleteLocation(itm));
  await Promise.all(promiseList);

  let input = { id: aisle.id };
  await API.graphql(graphqlOperation(deleteAisle, { input }));
};
